<div class="header">
  <spb-logo [routePath]="['/', HOME_PATH]"
            title="XML-validering"/>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button/>
  @if (service.currentUser()) {
    <span>{{ service.currentUser()?.name }}</span>
    <button [style.margin-right.rem]="1" [matMenuTriggerFor]="menu"
            mat-icon-button>
      <mat-icon [style.margin-top.px]="1">menu</mat-icon>
    </button>
  }
</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="[HOME_PATH]" mat-menu-item>
    <mat-icon>home</mat-icon>
    Start
  </button>
  <button [routerLink]="['/', HOME_PATH, 'upload']" mat-menu-item>
    <mat-icon>upload</mat-icon>
    Ladda upp
  </button>
  <button [routerLink]="['/', HOME_PATH, 'analyze']" mat-menu-item>
    <mat-icon>analytics</mat-icon>
    Analysera
  </button>
</mat-menu>
